/**
 * Created with JetBrains WebStorm.
 * Subscription: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Subscription_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/subscriptions/:id',{}, {
            query: { method: 'GET', isArray: true },
            update : { method: 'POST', url:'rest/subscription/store-app/:storeAppCode'},
            create : { method: 'PUT', url:'rest/subscription/store-app/:storeAppCode'},
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Subscription',["Subscription_Resource","StoreAppData","SubscriptionData",
        function (Subscription_Resource,StoreAppData,SubscriptionData)
    {
        //Subscription inherit of $resource

        var Subscription = function (resource,company) {
            // Call the parent constructor
            this.id = null;
            this.timeCreated = null;
            this.isDeleted = false;
            this.company = company;
            this.storeApp = null;
            this._storeAppId = null;
            this.isActive = null;
            this.price = null;
            this.trialTime = null;
            this.percentDiscount = 0;
            this.historyUsages = [];
            this.annualInvoiceNumber = null;
            if (resource!==undefined && resource!=null) {
                if (resource.timeCreated) {
                    this.timeCreated = new Date(resource.timeCreated);
                }
                if (!this.id) {
                    this.id = resource.id;
                }
                this._storeAppId = resource.storeAppId;
                this.isActive = resource.isActive;
                this.price = resource.price;
                this.percentDiscount = resource.percentDiscount;
                this.trialTime = resource.trialTime;
                this.annualInvoiceNumber = resource.annualInvoiceNumber;
                let usage;
                if (resource.historyUsages) {
                    for (let i= 0;i<resource.historyUsages.length;i++) {
                        usage = {startDate:null,endDate:null};
                        if (resource.historyUsages[i].startDate) {
                            usage.startDate =  new Date(resource.historyUsages[i].startDate);
                        }
                        if (resource.historyUsages[i].endDate) {
                            usage.endDate =  new Date(resource.historyUsages[i].endDate);
                        }
                        this.historyUsages.push(usage);
                    }
                }
            }
            SubscriptionData.add(this);
        };

        Subscription.prototype.getObjectResource = function() {
            var rsSub = new Subscription_Resource();
            rsSub.id =  this.id;
            if (this.storeApp)
                rsSub.storeAppId = this.storeApp.id;

            if (this.company)
                rsSub.companyCode = this.company.code;
            rsSub.isActive = this.isActive;
            rsSub.price = this.price;
            rsSub.percentDiscount = this.percentDiscount;
            rsSub.trialTime = this.trialTime ;
            rsSub.annualInvoiceNumber = this.annualInvoiceNumber ;
            return rsSub;
        };

        Subscription.prototype.getSavingObjectResource = function() {
            let rsSub = new Subscription_Resource();
            if (this.storeApp) {
                rsSub.storeAppId = this.storeApp.id;
            }
            rsSub.isActive = this.isActive;
            rsSub.price = this.price;
            return rsSub;
        };

        Subscription.prototype.loadRef = function() {
            this.storeApp = StoreAppData.getById(this._storeAppId);
        };
        return Subscription;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SubscriptionSrv',["$log","Subscription_Resource","Subscription","ServerSrv","InvoiceSrv",
        function ($log,Subscription_Resource,Subscription,ServerSrv,InvoiceSrv)
        {
            let  subscriptionSrv = {};


            subscriptionSrv.create = function (subscription, successFunction, errorFunction) {
                ServerSrv.startSavingProcess(subscriptionSrv.createSync, subscription, successFunction, errorFunction);
            };

            subscriptionSrv.createSync = function (subscription, successFunction, errorFunction) {
                let subscriptionRes = subscription.getSavingObjectResource();
                subscriptionRes.$create({storeAppCode : subscription.storeApp.code},
                    function (data) {
                        try {
                            if(subscription.company) {
                                InvoiceSrv.generateEstimateInvoice(subscription.company);
                            }
                            subscription.id = data.id;
                            if (successFunction != undefined) {
                                successFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        try {
                            if (errorFunction != undefined) {
                                errorFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            subscriptionSrv.update = function (subscription, successFunction, errorFunction) {
                ServerSrv.startSavingProcess(subscriptionSrv.updateSync, subscription, successFunction, errorFunction);
            };

            subscriptionSrv.updateSync = function (subscription, successFunction, errorFunction) {
                let subscriptionRes = subscription.getSavingObjectResource();
                subscriptionRes.$update({storeAppCode : subscription.storeApp.code},
                    function (data) {
                        try {
                            if(subscription.company) {
                                InvoiceSrv.generateEstimateInvoice(subscription.company);
                            }
                            if (successFunction != undefined) {
                                successFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        try {
                            if (errorFunction != undefined) {
                                errorFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
            return subscriptionSrv;
        }
]);

angular.module('FlexyBeautyApp.services').
    factory('SubscriptionData',["$log", function ($log)
    {
        var  subscriptionData =
        {
            indexActivities : []
        };
        subscriptionData.getById =  function(subscriptionId)
        {
            for (var i=0;i<this.indexActivities.length;i++)
                if (this.indexActivities[i].id==subscriptionId)
                    return this.indexActivities[i];
            return null;
        };
        subscriptionData.getByCode =  function(subscriptionCode)
        {
            for (var i=0;i<this.indexActivities.length;i++)
                if (this.indexActivities[i].code==subscriptionCode)
                    return this.indexActivities[i];
            return null;
        }
        subscriptionData.getIndexOf =  function(subscription)
        {
            if (subscription)
                return this.indexActivities.indexOf(subscription);
            return -1;
        }
        subscriptionData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexActivities.length)
                return this.indexActivities[index];
            else
                return null;
        }
        subscriptionData.add =  function(subscription)
        {
            this.indexActivities.push(subscription);
            return this.indexActivities.length-1;
        }
        subscriptionData.clear =  function()
        {
            subscriptionData.indexActivities = [];
        }


        return subscriptionData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/Subscription.js